/* unplugin-vue-components disabled */import { render } from "./user-companies.vue?vue&type=template&id=267652f7&scoped=true"
import script from "./user-companies.vue?vue&type=script&lang=js"
export * from "./user-companies.vue?vue&type=script&lang=js"

import "./user-companies.vue?vue&type=style&index=0&id=267652f7&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-267652f7"],['__file',"src/pages/tenants/user/companies/user-companies.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "267652f7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('267652f7', __exports__)) {
    api.reload('267652f7', __exports__)
  }
  
  module.hot.accept("./user-companies.vue?vue&type=template&id=267652f7&scoped=true", () => {
    api.rerender('267652f7', render)
  })

}


export default __exports__